import styles from './DashboardCard.module.scss';
import Icon from '../../../components/Icon';
import { Text } from '../../../components/typography';
import classNames from 'classnames';
import { assetTypeIcons, customColors } from '../../../utilities';
import Label from '../../../components/action_items/Label';
import { keys } from '../../../utilities/translator/translation_keys';
import { useTranslation } from 'react-i18next';
import TextWithIcon from '../../../components/typography/TextWithIcon';

export default function DashboardCard({
  icon,
  iconColor,
  header,
  subtext,
  rightContent,
  onClick = () => {},
  className,
  workspace = null,
  status = {},
  vehicle = null,
}) {
  const { t } = useTranslation();
  return (
    <div className={styles.container} onClick={onClick}>
      <Text weight="semiBold" size="sm-md" noMargin truncate>
        {header}
      </Text>
      <div className={classNames(styles.content, styles[className])}>
        <div className={styles.header}>
          <div className={styles.flexRow}>
            <Icon
              color={iconColor}
              className={styles[iconColor]}
              style={{
                color: customColors[iconColor?.toUpperCase()] || iconColor,
              }}
            >
              {icon || 'circle'}
            </Icon>
            <div>
              {!!workspace ? (
                <Text size="xs" noMargin>
                  {workspace?.title || t(keys.common.SHARED)}
                </Text>
              ) : null}

              <TextWithIcon
                iconProps={{ fontSize: '0.9rem' }}
                icon={
                  !!vehicle?.type
                    ? assetTypeIcons?.[vehicle.type] ?? 'local_shipping'
                    : ''
                }
                size="xs"
                color="secondary"
                noMargin
              >
                {subtext}
              </TextWithIcon>
            </div>
          </div>
          <div>
            {!!status.name && !!status.color ? (
              <Label className={styles.label} {...status} />
            ) : null}
          </div>
        </div>
      </div>{' '}
    </div>
  );
}
